<div class="anuncio"
  [class.anuncio--info]="vm.singleButton"
  [class.anuncio--header]="vm.headerBar"
  [class.anuncio--center-text]="vm.centerText"
  [class.anuncio--terminate-project]="data.mode === 'TERMINATE_PROJECT' || data.mode === 'TERMINATE_EMPLOYER_CONTRACTS'">

  <button class="anuncio__close-icon" *ngIf="vm.showCloseIcon" (click)="onCloseIconClick()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="anuncio__header" *ngIf="vm.headerBar">
    {{ vm.title }}
  </div>

  <mat-icon class="anuncio__icon" *ngIf="vm.icon && !vm.headerBar">
    {{ vm.icon }}
  </mat-icon>

  <div class="dialog-icon-wrapper" *ngIf="vm.customIcon === 'unverified-email'">
    <div class="circle-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="#FF9800" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"/>
      </svg>
      <div class="warning-badge">
        <mat-icon>error_outline</mat-icon>
      </div>
    </div>
  </div>

  <div class="dialog-icon-wrapper" *ngIf="vm.customIcon === 'verified-email'">
    <div class="circle-icon">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="#10b981" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"/>
      </svg>
      <div class="success-badge">
        <mat-icon>check_circle</mat-icon>
      </div>
    </div>
  </div>

  <div class="anuncio__title" *ngIf="!vm.headerBar" [innerHTML]="vm.title">
  </div>

  <div class="anuncio__body" [class.anuncio__body--header]="vm.headerBar">
    <div class="anuncio__instructions-box" *ngIf="vm.sectionLabel; else plainContent">
      <div class="anuncio__section-label">
        <mat-icon>info_outline</mat-icon>
        <span>{{ vm.sectionLabel }}</span>
      </div>

      <div class="anuncio__intro" *ngIf="vm.introText">
        {{ vm.introText }}
      </div>

      <div class="anuncio__content" *ngIf="data.mode !== 'COMMENT'">
        <div class="anuncio__line" [class.anuncio__line--numbered]="vm.numbered" *ngFor="let line of vm.lines; let i = index">
          {{
            vm.numbered
              ? (i + 1) + '.'
              : (vm.singleButton ? '' : '-')
          }}
          {{ line }}
        </div>
      </div>

      <!--
        En liquidación el aviso queda dentro del recuadro
        verde de instrucciones, como en la referencia.
      -->
      <div class="anuncio__warning anuncio__warning--inside"
        *ngIf="vm.warningText && (data.mode === 'TERMINATE_PROJECT' || data.mode === 'TERMINATE_EMPLOYER_CONTRACTS')">
        <mat-icon>warning_amber</mat-icon>
        <span>{{ vm.warningText }}</span>
      </div>
    </div>

    <ng-template #plainContent>
      <div class="anuncio__content" *ngIf="data.mode !== 'COMMENT'">
        <div class="anuncio__line" *ngFor="let line of vm.lines">
          {{ vm.singleButton || vm.centerText ? '' : '-' }}
          {{ line }}
        </div>
        <div class="anuncio__line secondary-text" *ngIf="vm.secondaryText">
          {{ vm.secondaryText }}
        </div>
      </div>
    </ng-template>

    <!-- Para todos los otros modos, el aviso conserva exactamente su ubicación original.-->
    <div class="anuncio__warning" *ngIf="vm.warningText && data.mode !== 'TERMINATE_PROJECT' && data.mode !== 'TERMINATE_EMPLOYER_CONTRACTS'">
      <mat-icon>warning</mat-icon>
      <span>{{ vm.warningText }}</span>
    </div>
  </div>

  <ng-container *ngIf="data.mode === 'COMMENT'">
    <div class="previous-comment-wrapper" *ngIf="data.item?.previousComment">
      <div class="previous-comment-label">
        Comentario anterior:
      </div>

      <div class="previous-comment-text">
        {{ data.item?.previousComment }}
      </div>
    </div>

    <mat-form-field appearance="outline" class="comment-field">
      <mat-label>COMENTARIO</mat-label>
      <textarea matInput rows="4" maxlength="280" [(ngModel)]="newComment"
        placeholder="Escribe un nuevo comentario..."></textarea>
      <mat-hint align="end">
        {{ newComment.length }}/280
      </mat-hint>

      <mat-error *ngIf="commentTouched && !newComment.trim()">
        El comentario es obligatorio
      </mat-error>
    </mat-form-field>
  </ng-container>

  <div class="anuncio__actions" [class.anuncio__actions--center]="vm.singleButton" [class.anuncio__actions--column]="vm.centerText">
    <button *ngIf="!vm.singleButton" mat-stroked-button type="button" class="btn-cancel"
      (click)="onCancel()">
      {{ vm.cancelText }}
    </button>

    <button mat-flat-button type="button" class="btn-confirm" [class.btn-confirm--blue]="vm.primaryBlue"
      (click)="onConfirm()">
      {{ vm.confirmText }}
    </button>
  </div>
</div>

